/** @jsx jsx */
import { Box, jsx } from 'theme-ui';

const Spacer = ({ height, marginTop }) => <Box sx={{ height, minHeight: height, marginTop, pointerEvents: 'none' }} />;

export default Spacer;
